(function () {
  function getStoreRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/').replace(/\/?$/, '/');
  }

  function getProductUrl(product) {
    var original = Array.prototype.find.call(product.querySelectorAll('a[href]'), function (link) {
      return !link.classList.contains('cinoton-review-showcase__more');
    });
    var href = original && original.getAttribute('href');
    if (href && href !== '#') return original.href;

    /* Legacy Gallery can output a product image and title without its URL.
       Keep Show More useful in that case by opening a product-only store
       search for the exact Judge.me title instead of inventing a handle. */
    var title = product.querySelector('.jdgm-carousel-item__product-title, .jdgm-carousel-item__product-name');
    var label = title && (title.textContent || '').trim();
    if (!label) return '';
    return getStoreRoot() + 'search?q=' + encodeURIComponent(label) + '&type=product';
  }

  function addInitials(root) {
    root.querySelectorAll('.jdgm-carousel-item__reviewer-name').forEach(function (name) {
      var header = name.parentElement;
      var review = name.closest('.jdgm-carousel-item__review-wrapper');
      if (!review || !header || header === review) return;
      var oldAvatar = name.querySelector('.cinoton-review-showcase__avatar');
      if (oldAvatar) oldAvatar.remove();
      var label = (name.textContent || '').trim();
      if (!label) return;
      var initials = label.split(/\s+/).slice(0, 2).map(function (word) {
        return word.charAt(0).toUpperCase();
      }).join('');
      header.classList.add('cinoton-review-showcase__reviewer');
      var avatar = header.querySelector('.cinoton-review-showcase__avatar');
      if (!avatar) {
        avatar = document.createElement('span');
        avatar.className = 'cinoton-review-showcase__avatar';
        avatar.setAttribute('aria-hidden', 'true');
        header.prepend(avatar);
      }
      if (avatar.textContent !== initials) avatar.textContent = initials;
      var rating = header.querySelector('.jdgm-carousel-item__review-rating');
      if (!rating) rating = review.querySelector('.jdgm-carousel-item__review-rating');
      if (rating) {
        if (rating.parentElement !== header) header.append(rating);
        rating.classList.add('cinoton-review-showcase__rating');
        review.classList.add('cinoton-review-showcase__has-header');
      }
    });
    root.querySelectorAll('.jdgm-carousel-item').forEach(function (item) {
      var product = item.querySelector('.jdgm-carousel-item__product-wrapper');
      if (!product) return;
      var url = getProductUrl(product);
      if (!url) return;
      var more = product.querySelector('.cinoton-review-showcase__more');
      if (!more) {
        more = document.createElement('a');
        more.className = 'cinoton-review-showcase__more';
        more.textContent = 'Show More';
        product.append(more);
      }
      if (more.href !== url) more.href = url;
      var title = product.querySelector('.jdgm-carousel-item__product-title, .jdgm-carousel-item__product-name');
      if (title) more.setAttribute('aria-label', 'Show more about ' + (title.textContent || '').trim());
    });
  }

  function init(root) {
    var host = root.querySelector('.cinoton-review-showcase__widget');
    if (!host) return;
    addInitials(host);
    if (host.__cinotonReviewObserver) return;
    host.__cinotonReviewObserver = new MutationObserver(function () { addInitials(host); });
    host.__cinotonReviewObserver.observe(host, { childList: true, characterData: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll('.cinoton-review-showcase').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.cinoton-review-showcase__widget').forEach(function (host) {
      if (host.__cinotonReviewObserver) host.__cinotonReviewObserver.disconnect();
      delete host.__cinotonReviewObserver;
    });
  });
})();
